import type { SVGProps } from 'react';

const Borrow = (props?: SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M4.83333 12.8333H3.16667V8.5H4.83333V9.83333M4.83333 12.8333V9.83333M4.83333 12.8333C9.33333 12.8333 12.8333 10.6667 12.8333 10.6667V9.16667H8.83333M4.83333 9.83333L7.18667 8.57867C7.28308 8.52715 7.39069 8.50014 7.5 8.5H8.16667C8.34348 8.5 8.51305 8.57024 8.63807 8.69526C8.76309 8.82029 8.83333 8.98986 8.83333 9.16667M8.83333 9.16667V10L7.16667 10.8333"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.3689 4.55434C9.39238 4.49769 9.4268 4.44623 9.47018 4.4029C9.51352 4.35951 9.56498 4.3251 9.62162 4.30162C9.67827 4.27813 9.73899 4.26605 9.8003 4.26605C9.86162 4.26605 9.92234 4.27813 9.97899 4.30162C10.0356 4.3251 10.0871 4.35951 10.1304 4.4029L11.2001 5.47317V1.9334C11.2001 1.80964 11.2493 1.69096 11.3368 1.60346C11.4243 1.51595 11.543 1.46679 11.6667 1.46679C11.7905 1.46679 11.9092 1.51595 11.9967 1.60346C12.0842 1.69096 12.1333 1.80964 12.1333 1.9334V5.47317L13.203 4.4029C13.2464 4.35954 13.2978 4.32516 13.3545 4.30169C13.4111 4.27823 13.4718 4.26616 13.5331 4.26616C13.5944 4.26616 13.6552 4.27823 13.7118 4.30169C13.7684 4.32516 13.8199 4.35954 13.8633 4.4029C13.9066 4.44625 13.941 4.49772 13.9645 4.55436C13.9879 4.611 14 4.67171 14 4.73302C14 4.79433 13.9879 4.85504 13.9645 4.91168C13.941 4.96832 13.9066 5.01979 13.8633 5.06314L11.9968 6.92956C11.9535 6.97294 11.902 7.00736 11.8454 7.03084C11.7888 7.05432 11.728 7.06641 11.6667 7.06641C11.6054 7.06641 11.5447 7.05432 11.488 7.03084C11.4314 7.00736 11.3799 6.97294 11.3366 6.92956L9.47018 5.06314C9.4268 5.01981 9.39238 4.96835 9.3689 4.9117C9.34542 4.85506 9.33333 4.79434 9.33333 4.73302C9.33333 4.6717 9.34542 4.61098 9.3689 4.55434Z"
      fill="currentColor"
    />
  </svg>
);

export default Borrow;
